import { render, staticRenderFns } from "./DadosGeraisEdicao.vue?vue&type=template&id=9bca8aec"
import script from "./DadosGeraisEdicao.vue?vue&type=script&lang=js"
export * from "./DadosGeraisEdicao.vue?vue&type=script&lang=js"
import style0 from "./DadosGeraisEdicao.vue?vue&type=style&index=0&id=9bca8aec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports